import { create } from "zustand";
import { persist } from "zustand/middleware";
import { syncPersistedPreferences } from "./sync-persisted-preferences";

type Settings = {
  autoUpdate: boolean;
  setAutoUpdate: (v: boolean) => void;
};

export const useUpdateSettings = create<Settings>()(
  persist(
    (set) => ({
      autoUpdate: true,
      setAutoUpdate: (v) => set({ autoUpdate: v }),
    }),
    { name: "denker_desktop_update_settings" },
  ),
);

const stopPreferenceSync = syncPersistedPreferences({
  name: "updates",
  read: () => ({ autoUpdate: useUpdateSettings.getState().autoUpdate }),
  subscribe: useUpdateSettings.subscribe,
  apply: (value) => {
    if (
      value &&
      typeof value === "object" &&
      "autoUpdate" in value &&
      typeof value.autoUpdate === "boolean"
    ) {
      useUpdateSettings.setState({ autoUpdate: value.autoUpdate });
    }
  },
});
if (import.meta.hot) import.meta.hot.dispose(stopPreferenceSync);
